
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetInvoiceDetail, GetReturn, GetReturnItems } from "../../../APIServices/ProductionService/Return/returnThunk";

export const useReturn = () => {
    const dispatch = useDispatch();
    const { ReturnList = [], loading,InvoiceDetail =[], error,PostReturnResponse } = useSelector((state) => state.ReturnData ?? {});
    
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [openManual, setOpenManual] = useState(true);
    const [selectedItem, setSelectedItem] = useState({});
    const [deliveryNo, setDeliveryNo] = useState({});
    const [formValues, setFormValues] = useState({});
    const [initialValue, setInitialValue] = useState({});
    const [tableRows, setTableRows] = useState([]);
    const [InProgress, setInProgress] = useState({
        returnDetails: false,
        returnItems: false,
        postReturn: false,
        getInvoiceDetail:false
      });

 
    useEffect(() => {
        setInProgress((prev) => ({
            ...prev,
            returnDetails: true,
          }));
        dispatch(GetReturn());
    }, [dispatch]);

    const openModal = useCallback((item, field) => {
        setSelectedItem(prev => ({
            ...prev,
            [field]: item.vehicle_Number
        }));
        setInitialValue(item);
        setIsDialogOpen(true);
        setTableRows([]);
    }, []);

    const handleInputModeChange = useCallback((mode) => {
        setOpenManual(mode === "manual");
    }, []);

  
    const handleSelectDelivery = useCallback((items,field) => {
   setFormValues({});
        setDeliveryNo(prev => ({
            ...prev,
            [field]: items.Delivery_Number,
            ['docEntry']:items.DocEntry
        }));
        // const valuesForApi = items.map(item => item.value);
        setInProgress((prev) => ({
            ...prev,
            returnItems: true,
            getInvoiceDetail:true,
          }));
        dispatch(GetInvoiceDetail(items.DocEntry));
        dispatch(GetReturnItems(items.DocEntry));
    }, [dispatch]);
    
    const handleSelectValue = useCallback((item, field) => {
        setFormValues(prev => {
            if (field === "item_Code" || field === "item_Name") {
                const updatedValues = {
                    ...prev,
                    item_Code: item.item_Code,
                    item_Name: item.item_Name,
                    iweight: item?.iWeight,
                    lineNum: item?.lineNum
                };
                if (prev.Receipt_Type) {
                    updatedValues.batch_Number = generateBatchNo(prev.Receipt_Type.value, updatedValues);
                }
                return updatedValues;
            } else if (field === "Receipt_Type") {
                const generatedBatch = generateBatchNo(item.value, prev);
                return {
                    ...prev,
                    [field]: item,
                    batch_Number: generatedBatch,
                };
            } 
            else if (field === "batch_Number") {
                const batchDetail = InvoiceDetail?.find(
                    x => x.batch_Number == item?.value
                );
                return {
                    ...prev,
                    batch_Number: item?.value,
                    InvoiceDocEntry: batchDetail?.inVoiceDocEntry,
                    Quantity: batchDetail?.quantity || "",
                    Weight: batchDetail?.weight || "",
                    lineNum: batchDetail?.lineNum
                };
            }else {
                return {
                    ...prev,
                    [field]: item,
                };
            }
        });
    }, [InvoiceDetail, formValues]);

    console.log("FormValues",formValues);
    
    const handleValueChange = (value, field) => {
      setFormValues((prev) => {
        const updated = {
          ...prev,
          [field]: value,
        };
        if (field === "Quantity") {
          const quantity = Number(value) || 0;
          const iWeight = Number(formValues.iweight) || 0;
          updated.Weight = Number((quantity * iWeight).toFixed(2));
        }
    
        return updated;
      });
    };
    const generateBatchNo = (Item, formValues) => {
        const currentDate = new Date();
        const day = String(currentDate.getDate()).padStart(2, "0");
        const month = String(currentDate.getMonth() + 1).padStart(2, "0");
        const currentYear = currentDate.getFullYear();
        const yearAlphabet = String.fromCharCode(65 + (currentYear - 2025));
    const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
//   const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  const ms = String(currentDate.getMilliseconds()).padStart(3, "0");

  const formattedDate = `${day}${yearAlphabet}${hours}${minutes}${ms}`;

  return `${Item}${formValues.item_Code}L${formValues.lineNum}${formattedDate}R`;
    };

    return {
        ReturnList,
        loading,
        error,
        isDialogOpen,tableRows, setTableRows,
        setIsDialogOpen,
        handleValueChange,
        openManual,
        setOpenManual,
        selectedItem,
        setSelectedItem,
        deliveryNo, setDeliveryNo,
        setInProgress,InProgress,
        setInitialValue,
        formValues,
        setFormValues,
        openModal,
        handleInputModeChange,
        handleSelectDelivery,
        handleSelectValue,
        initialValue
    };
};